class CampaignTimeline {
    constructor(rootElement) {
        this.activeIndex = 0;
        this.rootElement = rootElement;
        this.events = [...rootElement.querySelectorAll('.campaign-timeline__event')];
        this.expandableEvents = [...rootElement.querySelectorAll('.campaign-timeline__event.campaign-timeline__event--expandable')];
        this.buttons = [...rootElement.querySelectorAll('.campaign-timeline__timeline-item:not([disabled])')];
        this.timeline = rootElement.querySelector('.campaign-timeline__timeline');
        this.eventListElement = rootElement.querySelector('.campaign-timeline__events');
        this.controlsElement = rootElement.querySelector('.carousel-controls');
        this.controlsElementDots = [...this.controlsElement.querySelectorAll('.carousel-controls__dot')];
        this.prevButton = this.controlsElement.querySelector('.carousel-controls__button--prev');
        this.nextButton = this.controlsElement.querySelector('.carousel-controls__button--next');
        this.expandButtons = [...rootElement.querySelectorAll('.campaign-timeline__event-details-expand')];

        this.setFirstUpcomingActive();
        this.attachEvents();
        this.attachResizeListener();
    }

    attachEvents = () => {
        this.events.forEach((event, index) => {
            event.addEventListener('click', () => {
                this.handleEventClick(index);
            });
        });

        this.buttons.forEach((button, index) => {
            button.addEventListener('click', () => {
                this.handleButtonClick(index);
            });
        });

        this.expandButtons.forEach((expandButton, index) => {
            expandButton.addEventListener('click', () => {
                this.handleExpandClick(expandButton, index);
            });
        });

        this.prevButton.addEventListener('click', () => {
            this.handleControlsClick(false);
        });
        this.nextButton.addEventListener('click', () => {
            this.handleControlsClick(true);
        });
    };

    handleControlsClick = (increase) => {
        const currentIndex = this.controlsElementDots.findIndex(dot =>
            dot.classList.contains('carousel-controls__dots--active')
        );
        const nextIndex = increase ? currentIndex + 1 : currentIndex - 1;

        if (nextIndex < 0 || nextIndex >= this.controlsElementDots.length) return;

        this.updateActiveStates(nextIndex);
    };

    handleEventClick = (index) => {
        this.updateActiveStates(index);
    };

    handleButtonClick = (index) => {
        this.updateActiveStates(index);
    };

    handleExpandClick = (expandButton, index) => {
        const isExpanded = expandButton.classList.toggle('campaign-timeline__event-details-expand--expanded');
        const event = this.expandableEvents[index];
        event.classList.toggle('campaign-timeline__event--expanded', isExpanded);
        expandButton.textContent = isExpanded ? 'Dölj detaljer' : 'Läs detaljer';
        expandButton.setAttribute('aria-expanded', isExpanded);
    };

    updateActiveStates = (index) => {
        this.activeIndex = index;

        const totalGap = parseFloat(getComputedStyle(this.eventListElement).gap) * this.buttons.length;
        const scrollAmount = ((this.eventListElement.scrollWidth + totalGap / this.buttons.length) / this.buttons.length) * index;
        this.eventListElement.style.transform = `translateX(-${scrollAmount}px)`;

        this.updateActiveClass(this.buttons, index, 'campaign-timeline__timeline-item--active', false, true);
        this.updateActiveClass(this.events, index, 'campaign-timeline__event--active', true);
        this.updateActiveClass(this.controlsElementDots, index, 'carousel-controls__dots--active');

        this.synchronizeControlsStates(index);
        this.centerButtonInViewport(index);
    };

    updateActiveClass = (elements, index, className, manageAriaHidden = false, manageAriaExpanded = false) => {
        elements.forEach((el, elIndex) => {
            el.classList.remove(className);
            if (manageAriaHidden)
                el.setAttribute('aria-hidden', index !== elIndex);
            if (manageAriaExpanded)
                el.setAttribute('aria-expanded', index === elIndex);
        });

        elements[index].classList.add(className);
        if (manageAriaHidden)
            elements[index].setAttribute('aria-hidden', 'false');
    };

    synchronizeControlsStates = (index) => {
        const isFirst = index === 0;
        const isLast = index === this.controlsElementDots.length - 1;

        this.prevButton.classList.toggle('carousel-controls__button--disabled', isFirst);
        this.nextButton.classList.toggle('carousel-controls__button--disabled', isLast);

        this.prevButton.setAttribute('aria-hidden', isFirst);
        this.nextButton.setAttribute('aria-hidden', isLast);
    };

    centerButtonInViewport = (index) => {
        const button = this.buttons[index];
        const timelineRect = this.timeline.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();
        const offset = buttonRect.left - timelineRect.left - (timelineRect.width - buttonRect.width) / 2;
        this.timeline.scrollTo({ left: offset + this.timeline.scrollLeft, behavior: 'smooth' });
    };

    attachResizeListener = () => {
        let resizeTimeout;

        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                this.recalculateTransform();
                this.recenterButtonOnResize();
            }, 250);
        });
    };

    recalculateTransform = () => {
        const totalGap = parseFloat(getComputedStyle(this.eventListElement).gap) * this.buttons.length;
        const scrollAmount = ((this.eventListElement.scrollWidth + totalGap / this.buttons.length) / this.buttons.length) * this.activeIndex;
        this.eventListElement.style.transform = `translateX(-${scrollAmount}px)`;
    };

    recenterButtonOnResize = () => {
        this.centerButtonInViewport(this.activeIndex);
    };

    setFirstUpcomingActive = () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        let activeIndex = this.buttons.findIndex(button => {
            const buttonDate = new Date(button.getAttribute('data-date'));
            return buttonDate >= today;
        });

        if (activeIndex === -1) {
            activeIndex = 0;
        }

        this.updateActiveStates(activeIndex);
    };


    setActiveClassByIndex = (elements, index, className, setActive = false) => {
        elements.forEach(el => el.classList.remove(className));
        elements[index].classList.add(className);
    };
}

document.addEventListener('DOMContentLoaded', () => {
    const timelines = document.querySelectorAll('.campaign-timeline');
    timelines.forEach(rootElement => new CampaignTimeline(rootElement));
});
